module.exports = __webpack_public_path__ + "static/media/Mobile9M.57dd2cf9.jpg";